import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "employeeGradeView",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.EMPLOYEE_GRADE.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.EMPLOYEE_GRADE.PERMISSIONS,
    },
    component: () => import("@/modules/EmployeeGrade/views/EmployeeGrade.vue"),
  },
];

export default routes;
